const policyObjects = {
  Gender: [
    {
      data: 1,
      name: "Male",
    },
    {
      data: 2,
      name: "Female",
    },
  ],
  "Marriage Status": [
    {
      data: 1,
      name: "Single",
    },
    {
      data: 2,
      name: "Married",
    },
    {
      data: 4,
      name: "Divorced",
    },
  ],
  "Employment Type": [
    {
      data: 1,
      name: "Permanent",
    },
    {
      data: 2,
      name: "Intern",
    },
    {
      data: 3,
      name: "Contract",
    },
  ],
};

export default policyObjects;

export const getCategoryKey = (key) => {
  switch (key) {
    case "Gender":
      return "gender";
    case "Marriage Status":
      return "marriage_status";
    case "Employment Type":
      return "employment_type";

    default:
      return null;
  }
};

export const formikInitialValue = {
  Gender: [
    {
      data: 1,
      status: 1,
    },
    {
      data: 2,
      status: 1,
    },
  ],
  "Marriage Status": [
    {
      data: 1,
      status: 1,
    },
    {
      data: 2,
      status: 1,
    },
    {
      data: 4,
      status: 1,
    },
  ],
  "Employment Type": [
    {
      data: 1,
      status: 1,
    },
    {
      data: 2,
      status: 1,
    },
    {
      data: 3,
      status: 1,
    },
  ],
};
